import React from "react";

import {
  DispensaryV3,
  DispensaryV3MerchandisedCampaign,
} from "@/custom-types/DispensariesV3";
import { useEventTracker } from "@/hooks/useEventTracker";
import { isPlatinum } from "@/utils/tiers";

import DispensaryCard from "@/components/botanic/DispensaryCard";
import TrackImpression from "@/components/TrackImpression";

const getMerchandisingCampaignId = (
  campaigns: DispensaryV3MerchandisedCampaign[],
) => {
  const dpp = campaigns?.find((campaign) => {
    return campaign.unitName === "delivery-platinum-placement";
  });

  return dpp?.id;
};

const DeliveryDispensaryCards: React.FC<{
  dispensaries: DispensaryV3[];
}> = ({ dispensaries }) => {
  const { publishEvent } = useEventTracker();

  const handleCardClick = (dispensary: DispensaryV3, index: number) => {
    publishEvent({
      action: "click",
      category: "Delivery Gate Flow",
      dispensaryId: dispensary.id,
      label: "dispensary card",
      merchandisingCampaignId: getMerchandisingCampaignId(
        dispensary.merchandisedCampaigns,
      ),
      trayNumber: index + 1,
    });
  };

  return (
    <div className="row" data-testid="dispensary-cards">
      {dispensaries.map((dispensary, index) => {
        const {
          coverPhotoUrl,
          deliveryServiceAreaRanges,
          flags,
          id,
          logoUrl,
          merchandisedCampaigns,
          name,
          reviewCount,
          premiumRank,
          slug,
          starRating,
          timeZone,
        } = dispensary;

        return (
          <div className="col md:col-1/3 mb-md max-md:last:mb-0" key={slug}>
            <TrackImpression
              className="h-full"
              trackingFunction={() =>
                publishEvent({
                  action: "impression",
                  category: "Delivery Gate Flow",
                  dispensaryId: id,
                  label: "dispensary card",
                  merchandisingCampaignId: getMerchandisingCampaignId(
                    merchandisedCampaigns,
                  ),
                  trayNumber: index + 1,
                })
              }
            >
              <DispensaryCard
                ctaOnClick={() => handleCardClick(dispensary, index)}
                className="h-full"
                currentStatus={dispensary.currentStatuses?.delivery}
                deliveryEnabled={flags.includes("delivery")}
                deliveryServiceAreaRanges={
                  deliveryServiceAreaRanges || undefined
                }
                dispensaryId={dispensary.id}
                isAd={isPlatinum(premiumRank)}
                inStoreCartEnabled={dispensary.inStoreCartEnabled}
                isNewDispensary={flags.includes("newDispensary")}
                logoUrl={logoUrl || undefined}
                name={name}
                onClick={() => handleCardClick(dispensary, index)}
                photoUrl={
                  isPlatinum(premiumRank)
                    ? coverPhotoUrl || undefined
                    : undefined
                }
                preorderConfigured={flags.includes("preorderConfigured")}
                rating={starRating}
                reviewCount={reviewCount}
                scheduleType="delivery"
                slug={slug}
                timeZone={timeZone}
                variant="platinum"
                useLegacyFulfillmentText
                flags={flags}
              />
            </TrackImpression>
          </div>
        );
      })}
    </div>
  );
};

export default DeliveryDispensaryCards;
